<template>
    <div id="app">
        <m-header :params="pageParams"></m-header>
        <section class="block-wrap content-wrap">
            <!--教育服务-->
            <div class="panel-wrap">
                <m-breadcrumb :link-list="linkList"></m-breadcrumb>

                <div class="block-content">
                    <div class="block-main mt20">
                        <div class="main-tit-col">双选会信息</div>
                        <div class="main-info-col">
                            <h2 class="main-title">
                                {{ pageData.jobfairInfo.title }}
                                <a href="#company-table" style="width:215px">
                                    <el-button size="mini"
                                        @click="applyMeet(pageData.jobfairInfo.schoolName, pageData.jobfairInfo.sourceWebUrl, pageData.jobfairInfo.id, 0)"
                                        style="max-height: 30px" type="primary" class="p-btn">
                                        单位报名
                                    </el-button>
                                    <el-button size="mini" style="max-height: 30px" type="primary" class="p-btn">
                                        查看参会单位
                                    </el-button>
                                </a>
                            </h2>
                            <p>举办时间：{{ dateFormat(pageData.jobfairInfo.meetTime, 'YYYY-MM-DD HH:mm') }} ~
                                {{ dateFormat(pageData.jobfairInfo.meetEndTime, 'YYYY-MM-DD HH:mm') }} </p>
                            <p>报名截止时间：{{ dateFormat(pageData.jobfairInfo.signLimitTime, 'YYYY-MM-DD HH:mm') }}</p>
                            <!-- <p>举办地点：{{ pageData.jobfairInfo.address }}</p> -->
                            <p>主办方：{{ pageData.jobfairInfo.organisers }}</p>
                            <p>点击人数：{{ pageData.jobfairInfo.viewCount }}</p>
                        </div>

                        <div class="main-tit-col">双选会说明</div>
                        <div class="main-info-col">
                            <section v-html="pageData.jobfairInfo.content"></section>
                        </div>

                        <div class="main-tit-col">参会单位</div>
                        <div class="main-info-col" style="padding: 20px 0px" id="company-table" v-loading="loading">
                            <div class="search-wrap">
                                <el-input class="search-item" style="width: 320px" v-model="searchParams.keyword"
                                    placeholder="请输入专业、招聘岗位、单位名称"></el-input>

                                <el-button type="primary" class="search-btn" @click="search">搜 索</el-button>
                            </div>

                            <el-table :data="pageData.companyList" style="width: 100%" :span-method="arraySpanMethod"
                                :cell-style="{ 'color': '#666666' }"
                                :header-cell-style="{ 'background-color': '#F4F7FC' }" border>
                                <!-- <el-table-column label="展位" width="0" prop="boothIndex"></el-table-column> -->

                                <el-table-column label="单位名称">
                                    <template slot-scope="scope">
                                        <span class="main-font" style="line-height: 50px"
                                            @click="goCompanyDetail(scope.row.applyId)">{{
                                                scope.row.companyName
                                            }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="需求岗位" width="215">
                                    <template slot-scope="scope">
                                        <span class="main-font" @click="goJobsDetail(scope.row.schoolJobId)">{{
                                            scope.row.jobName
                                        }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="需求专业" width="285" prop="professionals">
                                    <template #default="scope">
                                        <span>{{ scope.row.professionals || '不限专业' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="人数" width="100">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.jobNumber }}人</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="" width="140">
                                    <!-- <template slot-scope="scope">
                                        <el-button size="mini" type="primary" class="p-btn"
                                            @click="applyJob(scope.row.schoolName, scope.row.sourceWebUrl)"
                                            >申请职位
                                        </el-button> -->
                                    <template>
                                        <el-button size="mini" type="primary" class="p-btn"
                                            @click="applyMeet(pageData.jobfairInfo.schoolName, pageData.jobfairInfo.sourceWebUrl, pageData.jobfairInfo.id, 1)">申请职位
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="pager-wrap"
                                v-if="pageParams.pageInfo.totalCount > pageParams.pageInfo.pageSize">
                                <m-pager :total-count="pageParams.pageInfo.totalCount"
                                    :page-number="pageParams.pageInfo.page" :page-size="pageParams.pageInfo.pageSize"
                                    @changePage="changePage"></m-pager>
                            </div>
                        </div>
                    </div>
                    <div class="block-sidebar">
                        <header-list :header-list="pageData.sidebarTab"
                            :m-style="{ titleStyle: { 'font-size': '24px', 'top': '0px' }, lineStyle: { 'bottom': '-5px' } }"></header-list>

                        <div class="sidebar-body mt10">
                            <div v-if="pageData.nearJobfairList.length > 0">
                                <div class="sidebar-item" v-for="item in pageData.nearJobfairList" :key="item.id">
                                    <p class="title-font">{{ item.title }}</p>
                                    <p class="tip-font mt10">举办时间</p>
                                    <p class="tip-font mt10">{{ dateFormat(item.meetTime, 'YYYY-MM-DD') }} ~
                                        {{ dateFormat(item.meetEndTime, 'YYYY-MM-DD') }}</p>
                                    <el-button size="mini" type="primary" class="p-btn mt20"
                                        @click="applyMeet(item.schoolName, item.sourceWebUrl, item.id, 0)">单位报名
                                    </el-button>
                                </div>
                            </div>
                            <div v-else>
                                <el-empty description="暂无数据"></el-empty>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <m-footer></m-footer>
    </div>
</template>
<script>
import mFooter from "@/components/mFooter";
import mHeader from "@/components/mHeader";
import mBreadcrumb from "@/components/mBreadcrumb";
import mPager from "@/components/mPager";
import headerList from "@/components/headerList";
import moment from "moment";

export default {
    name: 'mNotice',
    data() {
        return {
            loading: true,
            pageState: {
                panelMenuIndex: 0,
                mergeData: {
                    column1Arr: [], // column1
                    column1Index: 0, // column1索引
                    column2Arr: [], // column2
                    column2Index: 0, // column2索引
                    column3Arr: [], // column3
                    column3Index: 0, // column3索引
                    column4Arr: [], // column4
                    column4Index: 0, // column4
                    column5Arr: [], // column5
                    column5Index: 0, // column5索引
                    column6Arr: [], // column6
                    column6Index: 0 // column6索引
                }
            },
            pageParams: {
                menuIndex: '/jobfair.html',
                // swipeHeight: '500px',
                pageInfo: {
                    totalCount: 1,
                    page: 1,
                    pageSize: 10
                },
            },
            searchParams: {
                keyword: ''
            },
            pageData: {
                jobfairInfo: {},
                companyList: [],
                nearJobfairList: [],
                sidebarTab: {
                    title: '近期双选会',
                    more: false
                },
            },
        }
    },
    computed: {
        linkList() {
            return [
                { "title": '招聘会', "link": 'jobfair.html' },
                { "title": '双选会', 'link': "jobfair.html" },
                { "title": '正文', 'link': "" }
            ]
        }
    },
    components: {
        mFooter, mHeader, mBreadcrumb, mPager, headerList
    },
    methods: {
        dateFormat(date, format) {
            return moment(date).format(format)
        },
        getDetail(id) {
            this.$api.getJobfairDetail({ id }).then(
                data => {
                    this.pageData.jobfairInfo = data;
                    this.changePage({ currentPage: 1, currentSize: 15 });
                }
            )
            this.$api.getRecentJobFairList({ limit: 3 }).then(data => {
                this.pageData.nearJobfairList = data;
            })
        },
        applyJob(source, url) {
            if (url) {
                this.$util.showLevelDialog(this, source, url)
            } else {
                window.location.href = process.env.VUE_APP_COMPANY_URL
            }
        },
        applyMeet(source, url, id, type = 0) {
            if (url) {
                this.$util.showLevelDialog(this, source, url)
            } else {
                if (type == 0)
                    window.open(process.env.VUE_APP_COMPANY_URL+'/tosignup?id=' + id)
                else {
                    window.open(process.env.VUE_APP_STUDENT_URL+'/details?id=' + id)
                }
            }
        },
        mergeInit() {
            this.pageState.mergeData = {
                column1Arr: [], // column1
                column1Index: 0, // column1索引
                column2Arr: [], // column2
                column2Index: 0, // column2索引
                column3Arr: [], // column3
                column3Index: 0, // column3索引
                column4Arr: [], // column4
                column4Index: 0, // column4索引
                column5Arr: [], // column5
                column5Index: 0, // column5索引
                column6Arr: [], // column6
                column6Index: 0, // column6索引
            }
        },
        merge(data) {
            this.mergeInit();
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.pageState.mergeData.column1Arr.push(1);
                        this.pageState.mergeData.column1Index = 0;
                        this.pageState.mergeData.column2Arr.push(1);
                        this.pageState.mergeData.column2Index = 0;
                        this.pageState.mergeData.column3Arr.push(1);
                        this.pageState.mergeData.column3Index = 0;
                        this.pageState.mergeData.column4Arr.push(1);
                        this.pageState.mergeData.column4Index = 0;
                        this.pageState.mergeData.column5Arr.push(1);
                        this.pageState.mergeData.column5Index = 0;
                        this.pageState.mergeData.column6Arr.push(1);
                        this.pageState.mergeData.column6Index = 0;
                    } else {
                        if (data[i].companyId === data[i - 1].companyId) {
                            this.pageState.mergeData.column1Arr[this.pageState.mergeData.column1Index] += 1;
                            this.pageState.mergeData.column1Arr.push(0);
                        } else {
                            this.pageState.mergeData.column1Arr.push(1);
                            this.pageState.mergeData.column1Index = i;
                        }

                        this.pageState.mergeData.column2Arr.push(1);
                        this.pageState.mergeData.column2Index = i;
                        this.pageState.mergeData.column3Arr.push(1);
                        this.pageState.mergeData.column3Index = i;
                        this.pageState.mergeData.column4Arr.push(1);
                        this.pageState.mergeData.column4Index = i;
                        this.pageState.mergeData.column5Arr.push(1);
                        this.pageState.mergeData.column5Index = i;
                        this.pageState.mergeData.column6Arr.push(1);
                        this.pageState.mergeData.column6Index = i;
                    }
                }
            }
        },

        arraySpanMethod({ row, column, rowIndex, columnIndex }) {

            console.log(row, column, rowIndex)

            if (columnIndex === 0) {
                const _row_1 = this.pageState.mergeData.column1Arr[rowIndex];
                const _col_1 = _row_1 > 0 ? 1 : 0;

                return {
                    rowspan: _row_1,
                    colspan: _col_1
                }
            } else if (columnIndex === 2) {
                // 第二列 column2
                const _row_2 = this.pageState.mergeData.column2Arr[rowIndex]
                const _col_2 = _row_2 > 0 ? 1 : 0
                return {
                    rowspan: _row_2,
                    colspan: _col_2
                }
            } else if (columnIndex === 3) {
                // 第三列 column3
                const _row_2 = this.pageState.mergeData.column3Arr[rowIndex]
                const _col_2 = _row_2 > 0 ? 1 : 0
                return {
                    rowspan: _row_2,
                    colspan: _col_2
                }
            } else if (columnIndex === 4) {
                // 第四列 column4
                const _row_2 = this.pageState.mergeData.column4Arr[rowIndex]
                const _col_2 = _row_2 > 0 ? 1 : 0
                return {
                    rowspan: _row_2,
                    colspan: _col_2
                }
            } else if (columnIndex === 5) {
                // 第五列 column5
                const _row_2 = this.pageState.mergeData.column5Arr[rowIndex]
                const _col_2 = _row_2 > 0 ? 1 : 0
                return {
                    rowspan: _row_2,
                    colspan: _col_2
                }
            } else if (columnIndex === 6) {
                // 第六列 column6
                const _row_2 = this.pageState.mergeData.column6Arr[rowIndex]
                const _col_2 = _row_2 > 0 ? 1 : 0
                return {
                    rowspan: _row_2,
                    colspan: _col_2
                }
            }
        },
        //翻页
        changePage(page) {
            this.loading = true;
            this.pageParams.pageInfo.page = page.currentPage
            this.pageParams.pageInfo.pageSize = page.currentSize
            let params = {
                ...this.pageParams.pageInfo,
                bothmeetId: this.pageData.jobfairInfo.id,
                keyword: this.searchParams.keyword
            }
            this.$api.getCompanyList(params).then(data => {
                const { items, total } = data;
                this.pageData.companyList = items;
                this.pageParams.pageInfo.totalCount = total;
                //2.设置表格合并数据
                this.merge(this.pageData.companyList);
                this.loading = false
            });
        },
        search() {
            this.changePage({ currentPage: 1, currentSize: 15 });
        },

        goDetail(type, id) {
            let url = `${type}-detail.html?id=${id}&isSchoolJob=true`;
            window.open(url);
        },

        goCompanyDetail(id) {
            let url = `company-detail.html?applyId=${id}&isSchoolJob=true`;
            window.open(url);
        },
        goJobsDetail(id) {
            this.goDetail('jobs', id);
        },
        initPageInfo() {
            this.pageParams.pageInfo = {
                totalCount: 15,
                page: 1,
                pageSize: 15
            }
        },
    },
    created() {
        let id = this.$util.getQueryString("id");
        this.getDetail(id);
    }
}
</script>
<style scoped lang="scss">
@import "@/common/sass/common.scss";

.content-wrap {
    width: 1400px;
    margin: 0 auto;
    overflow: hidden;
}

.panel-wrap {
    margin-top: 30px;
    background-color: #ffffff;

    .block-content {
        display: flex;
        width: 100%;
        justify-content: space-between;

        .block-main {
            width: 1120px;

            .main-tit-col {
                margin-top: 10px;
                height: 50px;
                line-height: 50px;
                background-color: #F4F7FC;
                padding: 0 20px;

                font-size: 16px;
                font-weight: bold;
                color: #333333;
                box-sizing: border-box;
                background-image: url("../../../public/imgs/col-bg.png");
                background-position: left top;
                background-size: 11px 11px;
                background-repeat: no-repeat;
            }

            .main-info-col {
                padding: 20px;
                background-color: #ffffff;
                font-size: 14px;
                color: #555555;
                line-height: 30px;

                .main-font {
                    font-size: 15px;
                }

                .main-title {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    font-size: 24px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 15px;
                }
            }
        }
    }

    .block-sidebar {
        width: 240px;
        position: absolute;
        right: 0;
        top: 32px;

        .sidebar-body {
            padding: 0px 16px 40px;
            border: 1px solid #F2F2F2;
            box-sizing: border-box;
        }

        .sidebar-item {
            padding: 20px 0px;
            border-bottom: 1px dashed #E9E8E8;
        }
    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid #F4F7FC;
    }

    .el-table::before {
        content: none;
    }

    .search-wrap {
        width: 100%;
        height: 80px;
        padding: 10px 0px 25px;
        box-sizing: border-box;

        .search-item {
            margin-right: 10px;
        }

        .search-btn {
            background-color: $mainColor;
            border-color: $mainColor;
        }
    }

}

.pager-wrap {
    height: 100px;
    padding-top: 50px;
    box-sizing: border-box;
}
</style>